import { render, staticRenderFns } from "./ModalCodigo.vue?vue&type=template&id=5c5de530"
import script from "./ModalCodigo.vue?vue&type=script&lang=ts"
export * from "./ModalCodigo.vue?vue&type=script&lang=ts"
import style0 from "./ModalCodigo.vue?vue&type=style&index=0&id=5c5de530&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports